import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import Whitewash from '../../../../components/editable-cell/form-items/whitewash'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const whitewashColumn: CalculationColumn = {
    dataIndex: 'whitewash',
    title: <RotatedTitle>Белила</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Whitewash />,
    onCell: onAnyStandardCell,
}
